/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Form_Clients_Empty_DescriptionInputs */

const en_users_form_clients_empty_description = /** @type {(inputs: Users_Form_Clients_Empty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try another name or tax ID.`)
};

const pt_br2_users_form_clients_empty_description = /** @type {(inputs: Users_Form_Clients_Empty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tente outro nome ou CPF/CNPJ.`)
};

/**
* | output |
* | --- |
* | "Try another name or tax ID." |
*
* @param {Users_Form_Clients_Empty_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_form_clients_empty_description = /** @type {((inputs?: Users_Form_Clients_Empty_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Form_Clients_Empty_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_form_clients_empty_description(inputs)
	return pt_br2_users_form_clients_empty_description(inputs)
});